var exports = {
  "X": "SavedMessagesContent.module__scroller___SHl1QV",
  "W": "SavedMessagesContent.module__messageCard___SHl1QV",
};

module.exports = exports;
